import {StringUtil} from "../shared/string_util";

const adjectives = (await fetch("/usernamegen/adjectives.txt").then(res => res.text()))?.split("\n");
const nouns = (await fetch("/usernamegen/nouns.txt").then(res => res.text()))?.split("\n");
const blacklist = (await fetch("/usernamegen/blacklist.txt").then(res => res.text()))?.split("\n");

export async function genGuestName(): Promise<string> {
  let u1: string;
  do {
    u1 = adjectives?.[Math.floor(Math.random() * adjectives.length)];
  } while (blacklist?.includes(u1));
  let u2: string;
  do {
    u2 = nouns?.[Math.floor(Math.random() * nouns.length)];
  } while (blacklist?.includes(u2));
  return u1 && u2 ? StringUtil.toTitleCase(u1) + " " + StringUtil.toTitleCase(u2) : "Anonymous";
}